<template>
    <b-modal
        id="modalDotacao"
        v-model="mostrarModalDotacao"
        @show="preencherForm()"
        @hide="fecharModalDotacao()"
    >
        <div slot="modal-title">
            Dotação Orçamentária -
            <b-badge variant="warning">{{ acao }}</b-badge>
        </div>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codUnidade.$error ? false: null"
                    invalid-feedback="A unidade é obrigatória"
                >
                    <label>Unidade</label>
                    <model-list-select
                        :list="unidades"                    
                        option-text="codigoNomeUnidade"
                        option-value="codUnidade"
                        v-model="codUnidade"
                        @input="$v.codUnidade.$touch()"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codProjeto.$error ? false: null"
                    :invalid-feedback="`O projeto é obrigatório${this.codUnidade == null ? ', selecione a unidade primeiro' : ''}`"
                >
                    <label>Projeto</label>
                    <model-list-select
                        :list="projetos"                    
                        option-text="codigoNomeProjeto"
                        option-value="codProjeto"
                        v-model="codProjeto"
                        @input="$v.codProjeto.$touch()"
                        :isDisabled="codUnidade == null"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="acao == 'INSERIR'">
            <b-col sm="12">
                <b-form-group
                    :state="$v.codAcao.$error ? false: null"
                    :invalid-feedback="`A ação é obrigatória${this.codProjeto == null ? ', selecione o projeto primeiro' : ''}`"
                >
                    <label>Ação</label>
                    <model-list-select
                        :list="acoes"                    
                        option-text="codigoNomeAcao"
                        option-value="codAcao"
                        v-model="codAcao"
                        @input="$v.codAcao.$touch()"
                        :isDisabled="codProjeto == null"
                    ></model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Percentual disponível para rateio</label>
                    <money
                        v-model="percentualDisponivelTemp"
                        v-bind="perc"
                        class="form-control text-right"
                        :disabled="true"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group
                    :state="$v.percentual.$error ? false : null"
                    :invalid-feedback="`O percentual deve ser um valor entre 0.00001 e ${this.percentualDisponivelTemp}`"
                >
                    <label>Percentual</label>
                    <money
                        v-model="percentual"
                        v-bind="perc"
                        class="form-control text-right"
                        @input.native="$v.percentual.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModalDotacao()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="confirmarSalvarDotacao()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required, maxValue, minValue } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        percentualTotal: {
            type: Number,
            default: () => 0
        },

        percentualDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        },

        projetos: {
            type: Array
        },
        
        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModalDotacao: false,
            percentualDisponivelTemp: 0,
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            perc: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '%',
                precision: 5,
                masked: false
            },
            percentual: 0,
            // justificativaApostilamento: ''
        }
    },

    methods: {
        obterUnidades() {
            this.$emit('obterUnidades')
        },

        obterProjetos() {
            let evento = {codUnidade: this.codUnidade}
            this.$emit('obterProjetos', evento)
        },

        obterAcoes() {
            let evento = {codUnidade: this.codUnidade, codProjeto: this.codProjeto}
            this.$emit('obterAcoes', evento)
        },

        fecharModalDotacao() {
            this.resetDotacao()
            this.$emit('modalFechado')
        },

        resetDotacao() {
            this.mostrarModalDotacao = false
            this.valorDisponivelTemp = 0
            this.erros = []
            this.codUnidade = null
            this.codProjeto = null
            this.codAcao = null
            this.valor = 0
            this.percentual = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.acao == 'INSERIR') {
                this.obterUnidades()
                this.percentualDisponivelTemp = this.percentualDisponivel
                this.percentual = this.percentualDisponivelTemp
            }
            if (this.acao == 'ATUALIZAR') {
                this.percentual = this.rateio.percentual
                this.percentualDisponivelTemp = this.percentualDisponivel + this.percentual
            }
        },

        confirmarSalvarDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a ${
                    this.acao == 'INSERIR' ? 'inserção' : 'atualização'
                } da dotação orçamentária?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDotacao()
                }
            })
        },

        salvarDotacao() {
            this.$store.dispatch('addRequest')
            if (this.acao == 'ATUALIZAR') {
                let dotacaoDto = {
                    codUnidade: this.rateio.codUnidade,
                    nomeUnidade: this.rateio.unidade,
                    codProjeto: this.rateio.codProjeto,
                    nomeProjeto: this.rateio.projeto,
                    codAcao: this.rateio.codAcao,
                    nomeAcao: this.rateio.acao,
                    percentual: this.percentual
                }
                this.$emit('atualizarRateio', dotacaoDto)
            } else {
                let dotacaoDto = {
                    codUnidade: this.codUnidade,
                    nomeUnidade: this.unidades.filter(u => {
                        return u.codUnidade == this.codUnidade
                    })[0].nome,
                    codProjeto: this.codProjeto,
                    nomeProjeto: this.projetos.filter(u => {
                        return u.codProjeto == this.codProjeto
                    })[0].nome,
                    codAcao: this.codAcao,
                    nomeAcao: this.acoes.filter(u => {
                        return u.codAcao == this.codAcao
                    })[0].nome,
                    percentual: this.percentual
                }
                this.$emit('inserirRateio', dotacaoDto)

            }

            this.fecharModalDotacao()
            this.$store.dispatch('setRecarregar', true)
            this.$store.dispatch('removeRequest')
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalDotacao = this.mostrarModal
        },

        codUnidade(newVal, oldVal) {
            if (newVal !== null && newVal !== '') {
                this.obterProjetos()
            } else {
                this.codUnidade = null
                this.codProjeto = null
            }
        },

        codProjeto(newVal, oldVal) {
            if (newVal !== null && newVal !== '') {
                this.obterAcoes()
            } else {
                this.codProjeto = null
                this.codAcao = null
            }
        },

        codAcao(newVal, oldVal) {
            if (newVal == '') {
                this.codAcao = null
            }
        }
    },

    validations: {
        codUnidade: {
            codUnidadeOk() {
                if (this.acao == 'INSERIR') {
                    return this.codUnidade != null
                }
                return true
            }
        },
        codProjeto: {
            codProjetoOk() {
                if (this.acao == 'INSERIR') {
                    return this.codProjeto != null
                }
                return true
            }
        },
        codAcao: {
            codAcaoOk() {
                if (this.acao == 'INSERIR') {
                    return this.codAcao != null
                }
                return true
            }
        },
        percentual: {
            required,
            minValue: minValue(0.00001),
            percOk() {
                return this.percentual <= this.percentualDisponivelTemp
            }
        },
    },

    components: {
        ModelListSelect
    }
}
</script>
